import React, { useState, useEffect } from 'react';
import { CheckCircle } from 'lucide-react';
import { submissionProcessService } from '../services/api';

function parseJson(value, fallback) {
  if (!value) return fallback;
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : fallback;
  } catch {
    return fallback;
  }
}

function SubmissionProcess() {
  const [steps, setSteps] = useState([]);
  const [summary, setSummary] = useState('');
  const [durations, setDurations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await submissionProcessService.get();
        if (response.data) {
          setSteps(parseJson(response.data.steps, []));
          setSummary(response.data.summary || '');
          setDurations(parseJson(response.data.durations, []));
        }
      } catch (error) {
        console.error('Error fetching submission process:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, []);

  if (loading) {
    return (
      <div className="bg-gray-50 min-h-screen">
        <div className="flex items-center justify-center h-64">
          <div className="text-gray-500">در حال بارگذاری...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-16">
        <div className="max-w-7xl mx-auto px-4">
          <h1 className="text-5xl font-bold mb-4">نحوه ارسال مقاله</h1>
          <p className="text-xl text-blue-100">مراحل کامل فرآیند ارسال و انتشار</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-16">
        {steps.length === 0 ? (
          <div className="text-center text-gray-500">محتوایی ثبت نشده</div>
        ) : (
          <div className="space-y-6">
            {steps.map((step, idx) => (
              <div key={idx} className="bg-white rounded-lg shadow-md p-8 border-r-4 border-blue-700">
                <div className="flex items-start gap-6">
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-700 to-blue-900 rounded-lg flex items-center justify-center text-white font-bold text-xl flex-shrink-0">
                    {step.number}
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-gray-900 mb-2">{step.title}</h3>
                    <p className="text-gray-600 mb-4">{step.description}</p>
                    <ul className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      {step.details && step.details.map((detail, detailIdx) => (
                        <li key={detailIdx} className="flex items-center gap-2 text-sm text-gray-700">
                          <CheckCircle size={16} className="text-blue-700 flex-shrink-0" />
                          {detail}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="mt-12 bg-blue-50 rounded-xl border-r-4 border-blue-700 p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">مدت زمان کل</h2>
          {summary ? (
            <p className="text-gray-700 mb-4 whitespace-pre-wrap">{summary}</p>
          ) : (
            <div className="text-gray-500 mb-4">خلاصه‌ای ثبت نشده</div>
          )}
          {durations.length === 0 ? (
            <div className="text-center text-gray-500">زمان‌بندی ثبت نشده</div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {durations.map((duration, idx) => (
                <div key={idx} className="bg-white rounded-lg p-4">
                  <p className="text-sm text-gray-600 mb-1">{duration.label}</p>
                  <p className="text-lg font-bold text-blue-700">{duration.value}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SubmissionProcess;
